import { get } from 'lodash-es';

import { emptyArray } from 'ui-components/default-props/empty';

export const selectRejectedFullfillmentPlans = (state) => get(state, 'fulfillmentPlansInOtherBatches', emptyArray);
